import { render, staticRenderFns } from "./ImportantNoteDialog.vue?vue&type=template&id=ed1c0880&"
import script from "./ImportantNoteDialog.vue?vue&type=script&lang=js&"
export * from "./ImportantNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports